import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    location: 'Mumbai',
    text: 'Ragini Masale changed the way I cook. The Garam Masala is unlike anything from the supermarket — it fills the whole kitchen with fragrance the moment it hits the pan.',
    rating: 5,
    avatar: 'PS',
    since: 'Customer since 2019',
  },
  {
    id: 2,
    name: 'Rajesh Kulkarni',
    location: 'Pune',
    text: 'I have been using their Chai Masala for 3 years now. Every morning is a ritual. The balance of ginger and cardamom is just perfect — never too sharp, always warm.',
    rating: 5,
    avatar: 'RK',
    since: 'Customer since 2021',
  },
  {
    id: 3,
    name: 'Ananya Iyer',
    location: 'Bangalore',
    text: 'As a chef, I am very particular about quality. Ragini\'s haldi is the richest colour I have seen. Authentic stone-ground quality that makes a genuine difference in taste.',
    rating: 5,
    avatar: 'AI',
    since: 'Customer since 2020',
  },
];

const Testimonials = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section className="testimonials" ref={ref}>
      <div className="container">
        <div className="section-header">
          <motion.div
            className="section-tag"
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
          >
            Reviews
          </motion.div>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.1, duration: 0.7 }}
          >
            Loved by <span className="gradient-text">20,000+ Families</span>
          </motion.h2>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.id}
              className="testimonial-card"
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: 0.15 + i * 0.12, duration: 0.7 }}
            >
              {/* Stars */}
              <div className="t-stars">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <span key={si} className="star">★</span>
                ))}
              </div>

              {/* Quote */}
              <div className="t-quote-mark">"</div>
              <p className="t-text">{t.text}</p>

              {/* Author */}
              <div className="t-author">
                <div className="t-avatar">
                  {t.avatar}
                </div>
                <div>
                  <div className="t-name">{t.name}</div>
                  <div className="t-location">{t.location} · {t.since}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust band */}
        <motion.div
          className="trust-band"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.6, duration: 0.7 }}
        >
          {[
            { icon: '🌿', label: '100% Natural', sub: 'No preservatives' },
            { icon: '🏆', label: 'Award Winning', sub: 'FSSAI certified' },
            { icon: '📦', label: 'Free Delivery', sub: 'Above ₹499' },
            { icon: '🔄', label: 'Easy Returns', sub: 'No questions asked' },
          ].map((item) => (
            <div key={item.label} className="trust-item">
              <span className="trust-icon">{item.icon}</span>
              <div>
                <div className="trust-label">{item.label}</div>
                <div className="trust-sub">{item.sub}</div>
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
